import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Menu } from 'lucide-react';
import { useCart } from '../../lib/cart';
import { useLanguage } from '../../lib/i18n';
import { LanguageSelector } from '../ui/LanguageSelector';
export function MarketplaceHeader() {
  const {
    getItemCount
  } = useCart();
  const {
    t
  } = useLanguage();
  const itemCount = getItemCount();
  return <header className="sticky top-0 z-40 w-full bg-[#0B0B0B] border-b border-white/10" data-id="element-1050">
      {/* Promo strip */}
      <div className="bg-gradient-to-r from-emerald-600 via-emerald-500 to-emerald-600 text-white text-center py-1.5 px-4" data-id="element-1051">
        <Link to="/r/capricho-de-canela" className="text-xs sm:text-sm font-bold hover:underline" data-id="element-1052">
          🎉 Capricho de Canela: ¡2do producto a mitad de precio! →
        </Link>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1053">
        <div className="flex justify-between items-center h-16" data-id="element-1054">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-id="element-1055">
            <div className="w-8 h-8 bg-[#C9A34E] rounded-lg flex items-center justify-center" data-id="element-1056">
              <span className="text-[#0B0B0B] font-bold text-lg leading-none" data-id="element-1057">
                N
              </span>
            </div>
            <span className="font-bold text-xl tracking-tight text-white" data-id="element-1058">
              NOIZA
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-1059">
            <Link to="/" className="text-sm font-medium text-white/60 hover:text-[#C9A34E] transition-colors" data-id="element-1060">
              {t('home')}
            </Link>
            <Link to="/restaurants" className="text-sm font-medium text-white/60 hover:text-[#C9A34E] transition-colors" data-id="element-1061">
              {t('restaurants')}
            </Link>
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-4" data-id="element-1062">
            <LanguageSelector data-id="element-1063" />

            <Link to="/cart" className="relative p-2 text-white/60 hover:text-white transition-colors rounded-full" data-id="element-1064">
              <ShoppingBag className="w-6 h-6" data-id="element-1065" />
              {itemCount > 0 && <span className="absolute top-0 right-0 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-bold leading-none text-[#0B0B0B] transform translate-x-1/4 -translate-y-1/4 bg-[#C9A34E] rounded-full min-w-[20px] h-[20px]" data-id="element-1066">
                  {itemCount}
                </span>}
            </Link>

            <button className="md:hidden p-2 text-white/60 hover:text-white rounded-full" data-id="element-1067">
              <Menu className="w-6 h-6" data-id="element-1068" />
            </button>
          </div>
        </div>
      </div>
    </header>;
}